export const checkSaved = () => {
  const currentState = sessionStorage.getItem('editSaved')
  if (currentState === 'true') {
    return true
  } else {
    window.alert('Save before you navigate away!')
    return false
  }
}
